import { z, ZodSchema } from "zod";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@shared/services/api/formatFirebaseError";
import { registerUser } from "../utils/registerUser";
import { authEventBus } from "../auth.events";
import { Invitation } from "@platform/types/platform.types";

type Args = {
  invitation: Invitation;
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  onError?: (error: Error) => void;
};

export function useSignupMutation({
  invitation,
  onSuccess,
  schema,
  onError,
}: Args) {
  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await registerUser({
        data,
        inviteCode: invitation?.code,
        onError,
      });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: (data) => {
      authEventBus.emitEvent("auth:signup:completed", {
        invitation: invitation,
      });

      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useSignupMutation;
